import { SearchCombo, SearchQuery } from 'modules/workflows/types';
import walkSearchQueries, { isGeoSearchField, isSearchQueryField } from '../../walkSearchQueries';
import { YesNoSearchQueryLevels } from './fieldMatchUtils.constants';

/**
 * Parsing function that is run on save to massage the data into the correct format
 */
export const parseSearchQueryForSaving = (searchQuery: SearchQuery) => {
  if (!Array.isArray((searchQuery as SearchCombo)?.searchQueries)) {
    return searchQuery;
  }

  const searchQueries = [...(searchQuery as SearchCombo).searchQueries];

  walkSearchQueries(searchQueries, {
    callback: ({ query }) => {
      if (!isSearchQueryField(query)) return;
      if (isGeoSearchField(query)) {
        /**
         * The fields cannot be published with the lat/lon as strings, so they
         * need to be converted to floats.
         *
         * @see https://iterable.atlassian.net/browse/WF-5058
         */
        const { lat, lon } = query.location || {};
        if (lat) {
          query.location.lat = parseFloat(lat as unknown as string);
        }
        if (lon) {
          query.location.lon = parseFloat(lon as unknown as string);
        }
        /**
         * Value field needs to be deleted for geo location field to persist.
         *
         * @see https://iterable.atlassian.net/browse/WF-5058
         */

        delete query.value;
      }
    },
    maxLevel: YesNoSearchQueryLevels.Field,
  });

  return { ...searchQuery, searchQueries };
};
